import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { TippyInstance, TIPPY_REF } from '@ngneat/helipopper';

import { IIdentity, TooltipContext, anyFnExec } from '../../models';

@Component({
  selector: 'app-tooltip-message',
  templateUrl: './tooltip-message.component.html',
  styleUrls: ['./tooltip-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipMessageComponent<T extends IIdentity> {
  message: string;

  constructor(@Inject(TIPPY_REF) tippy: TippyInstance) {
    const tippyData = tippy.data;

    const context: TooltipContext<T> = {
      data: tippyData.data,
      columnDef: tippyData.column.columnDef,
      allowEditing: tippyData.options.editConfig?.allowEditing ?? true,
      allowDeleting: tippyData.options.deleteConfig?.allowDeleting ?? true,
      allowDeletingRow: anyFnExec(
        tippyData.options.rowConfig?.allowDeleting ?? true,
        tippyData.data
      ),
    };

    const tooltipMessage =
      tippyData.column.tooltip?.message ??
      tippyData.data[tippyData.column.columnDef];

    this.message = String(anyFnExec(tooltipMessage, context) ?? '')
      ?.trim()
      ?.replace(/\n/g, '<br/>');
  }
}
